var Handlebars = require("../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"NotificationBar-container NotificationBar--myArrow\">\r\n  <div class=\"NotificationBar-message\">"
    + container.escapeExpression((lookupProperty(helpers,"translate")||(depth0 && lookupProperty(depth0,"translate"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"myArrow","userNotification",{"name":"translate","hash":{},"data":data,"loc":{"start":{"line":2,"column":39},"end":{"line":2,"column":81}}}))
    + "</div>\r\n  <div class=\"NotificationBar-dismiss Icon Icon--cross js-dismissNotification\"></div>\r\n</div>\r\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./assets/components/Header/templates/_MyArrowUserNotification.hbs
// module id = 1114
// module chunks = 1